import firebase from '../../../config/firebase';
// uuid
import uuid from 'uuid';

const database = firebase.database();

/**
 * get all Coupons
 */
export function getCoupon(callback) {

  database.ref('coupons').on('value', function(snapshot) {
    if (snapshot.exists()) {
      const coupon = snapshot.val();
      callback(true, coupon, null);
    }
    else {
      callback(true, {}, null);
    }
  });
}

export function setCoupons(data, callback) {
  database.ref('coupons').set(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  })
}

export function updateCoupons(data, callback) {
  database.ref('coupons').update(data, function(error) {
    if (error) {
      callback(false, null, error);
    } else {
      callback(true, data, null);
    }
  })
}

export function createBarcode(id, barcode, callback) {
  const store = uuid.v4();
  // upload task
  let uploadTask = firebase
    .storage()
    .ref('barcodes')
    .child(store)
    .putString(barcode, 'base64', {contentType:'image/jpg'});
  // upload task deploy
  uploadTask.on('state_changed', function(snapshot) {
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    console.log('Upload is ' + progress + '% done');
    // for some reason I can only get callbacks working as needed
    // if I reverse them, so that's why they're backwards from the norm
    }, function(error) {
      callback(true, null, error);
    }, function() {
      // Handle successful uploads on complete
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
        var url = String(downloadURL);
        if (id) {
          database.ref('coupons')
            .child(id)
            .child('barcodeImage')
            .set(url);
        }
        callback(false, null, url);
      });
    }
  );
}
